import React from "react";
import "./styles.scss";

interface IInputProps {
  type?: string;
  placeholder?: string;
  size?: "sm" | "md" | "lg" | string;
  label?: string;
  disabled?: boolean;
  error?: string;
  name?: string;
  value?: string;
  id?: string;
  rows?: number;
  style?: React.CSSProperties;
  maxLength?: number;
  required?: boolean;
  endAdornment?: React.ReactNode; // <-- novo

  onChange?: (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  onBlur?: (
    ev: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  onKeyDown?: (
    ev: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
}

const Input = (props: IInputProps) => {
  const {
    type = "text",
    placeholder,
    size = "md",
    label,
    disabled,
    error,
    name,
    value,
    id,
    onChange,
    onBlur,
    onKeyDown,
    rows,
    style,
    maxLength,
    required = false,
    endAdornment, // <-- novo
  } = props;

  const className = `input whitespace-pre-wrap input--${size} ${error ? "input--error" : ""} paragraph ${endAdornment ? "input--has-adornment" : ""}`;

  return (
    <div className="input-wrapper">
      {label && (
        <label className={`label label--${size}`} htmlFor={id || label}>
          {label}
        </label>
      )}

      {type === "textarea" ? (
        <textarea
          id={id || label}
          name={name}
          value={value}
          placeholder={placeholder}
          rows={rows ?? 4}
          className={`${className} input--textarea`}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          style={style}
          maxLength={maxLength}
        />
      ) : (
        <div className="input-field-container">
          <input
            id={id || label}
            value={value}
            type={type}
            placeholder={placeholder}
            onKeyDown={
              onKeyDown as React.KeyboardEventHandler<HTMLInputElement>
            }
            className={className}
            disabled={disabled}
            name={name}
            onChange={onChange as React.ChangeEventHandler<HTMLInputElement>}
            onBlur={onBlur as React.FocusEventHandler<HTMLInputElement>}
            style={style}
            maxLength={maxLength}
            required={required}
          />
          {endAdornment && (
            <div className="input-field-adornment">{endAdornment}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default Input;
